import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "./Card";
import MiddleCard from "./MiddleCard";
import PreviousTxns from "./PreviousTxns";
import VirtualAssistant from "./VirtualAssistant";
import TotalTransaction from "./TotalTransaction";
import PieCharts from "./PieChart";
import FloatingIcon from "../common/FloatingIcon";
import {
  API_DASHBOARD_WITH_CONDITION,
  API_DASHBOARD_WITH_CONDITION1,
  API_DASHBOARD_WITH_CONDITION3,
  API_DASHBOARD_WITH_CONDITION2,
  FETCH_ALL_PAYIN_SERVICES,
  REPORT_ERROR_CODES,
  GET_DASHBOARD_CURRENT_DATA,
  API_DASHBOARD_WITH_CONDITION4,
} from "../utils/constant";
import SimpleBarChart from "./BarChart";
import useApiServices from "../utils/useApiServices";
import MerchantIcon from "../common/MerchantIcon";
import { serviceColors, errorCodes } from "../utils/ConstantKeys";
import icon1 from "../Assets/images/cardicons/bank3.jpeg";
import icon2 from "../Assets/images/cardicons/bank50.jpeg";
import icon3 from "../Assets/images/cardicons/credit50.jpeg";
import icon4 from "../Assets/images/cardicons/creditCard.jpeg";
import { Button } from "react-bootstrap";

const DashBoard = () => {
  const [boxData, setBoxData] = useState([]);
  // const [combinedApiRes, setCombinedApiRes] = useState([]);
  const [combinedApiRes1, setCombinedApiRes1] = useState([]);
  const [combinedApiRes2, setCombinedApiRes2] = useState([]);
  const [combinedApiRes3, setCombinedApiRes3] = useState([]);
  const [payinServices, setPayinServices] = useState([]);
  const [totalTransactionData, setTotalTransactionData] = useState([]);
  const [availablePayoutBalance, setAvailablePayoutBalance] = useState("");
  const [servicesPieChartData, setServicesPieChartData] = useState([]);
  const [errorCodelist, setErrorCodeList] = useState([]);
  const [data, setData] = useState({});
  const [merchantData, setMerchantData] = useState([]);
  const [mid, setMid] = useState("");
  const { apiCallFnforGet, apiCallFnforPost } = useApiServices();
  const [condition, setCondition] = useState("this year");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [currentAvailable, setCurrentAvailabe] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [detailsOn, setDetailsOn] = useState(false);

  const [dataForBoxes, setDataForBoxes] = useState(true);

  useEffect(() => {
    getDataCombined4();
  }, [condition, mid, setMid]);

  const HandleDetailShow = () => {
    setDetailsOn(true);
    getDataCombined1();
    getDataCombined2();
    getDataCombined3();
    getErrorCodeData();
  };
  const HandleDetailHide = () => {
    setDetailsOn(false);
  };

  useEffect(() => {
    DistributeData(combinedApiRes1, combinedApiRes2, combinedApiRes3);
  }, [combinedApiRes1, combinedApiRes2, combinedApiRes3]);

  const DistributeData = (
    combinedApiRes1,
    combinedApiRes2,
    combinedApiRes3
  ) => {
    const data = {
      mid: combinedApiRes1.mid,
      totalCount: combinedApiRes1.totalCount,
      totalAmt: combinedApiRes1.totalAmt,
      successCount: combinedApiRes3.successCount,
      failureCount: combinedApiRes3.failureCount,
      declined: combinedApiRes3.declined,
      payoutTotalCount: combinedApiRes1.payoutTotalCount,
      payoutSuccessCount: combinedApiRes1.payoutSuccessCount,
      payoutFailureCount: combinedApiRes1.payoutFailureCount,
      payoutPendingCount: combinedApiRes1.payoutPendingCount,
      filterTxnList: combinedApiRes1.filterTxnList,
    };

    // const data2 = {
    //   settlmentAmout: combinedApiRes.settlmentAmout,
    //   depositAmount: combinedApiRes.depositAmount,
    //   totalCommisionEarnedAmount: combinedApiRes.totalCommisionEarnedAmount,
    //   chragebackAmount: combinedApiRes.chragebackAmount,
    //   holdAmount: combinedApiRes.holdAmount,
    //   withdrawalAmount: combinedApiRes.withdrawalAmount,
    //   payAmount: combinedApiRes.payAmount,
    //   totalwalletBalance: combinedApiRes.totalwalletBalance,
    //   securityDepositAmount: combinedApiRes.securityDepositAmount,
    //   guranteeAmount: combinedApiRes.dropCreditAmount,
    //   dropCreditAmount: combinedApiRes.dropCreditAmount,
    //   totalAmt: combinedApiRes.totalAmt,
    //   withDrawToAccount: combinedApiRes.withDrawToAccount,
    //   withDrawTopayout: combinedApiRes.withDrawTopayout,
    //   settlementCharge:combinedApiRes.settlementCharge,
    //   directDeposite:combinedApiRes.directDeposite
    //    };

    const data2 = {
      totalAmt: combinedApiRes1.totalAmt,
      settlmentAmout: combinedApiRes1?.settelmentAmountNetAMtToWallet,
      settlementCharge: combinedApiRes1?.settlementCharge,
      settlmentGstCharge: combinedApiRes2?.settlmentGstCharge,
      depositAmount: combinedApiRes1?.securityDepositAmount,
      depositeToWallet: combinedApiRes2?.depositeToWallet,
      depositeToPayout: combinedApiRes2?.depositeToPayout,
      totalCommisionEarnedAmount: combinedApiRes2?.totalCommisionEarnedAmount,
      chragebackAmount: combinedApiRes1?.chragebackAmount,
      holdAmount: combinedApiRes3?.holdAmount,
      withdrawalAmount: combinedApiRes1?.withdrawalAmount,
      withDrawTopayout: combinedApiRes2?.withDrawTopayout,
      withDrawToAccount: combinedApiRes2?.withDrawToAccount,
      withdrawnTocredit: combinedApiRes2?.dropCreditAmount,
      payoutGstCharge: combinedApiRes1?.payoutGstCharge,
      payoutaccountCharge: combinedApiRes2?.payoutaccountCharge,
      payoutServiceCharge: combinedApiRes1?.payoutServiceCharge,
      payAmount: combinedApiRes3?.payAmount,
      totalwalletBalance: combinedApiRes1?.totalwalletBalance,
      securityDepositAmount: combinedApiRes1?.securityDepositAmount,
      guranteeAmount: combinedApiRes2?.guranteeAmount,
      dropCreditAmount: combinedApiRes2?.dropCreditAmount,
    };

    const data3 = {
      upiAmount: combinedApiRes1.map.upiAmount,
      wallet: combinedApiRes1.map.wallet,
      impsAmount: combinedApiRes1.map.impsAmount,
      offlineMerchantCount: combinedApiRes1?.offlineMerchantCount,
      onlineMerchantCount: combinedApiRes1?.onlineMerchantCount,
    };

    setBoxData(data2);
    setTotalTransactionData(data);
    setAvailablePayoutBalance(data3);
  };
  console.log(availablePayoutBalance);

  const getCurrentAvailableData = async () => {
    try {
      setShowLoader(true);
      console.log("mid", mid);
      const response = await apiCallFnforGet(
        GET_DASHBOARD_CURRENT_DATA + (mid || "na")
      );
      if (response.statusCode === 200) {
        setCurrentAvailabe(response);
        setShowLoader(false);
      } else {
        setCurrentAvailabe([]);
        setShowLoader(false);
      }
    } catch (error) {
      setBoxData(true);
      setShowLoader(false);
    }
  };

  useEffect(() => {
    getCurrentAvailableData();
  }, [mid, setMid]);

  useEffect(() => {
    console.log("CalledAgain");
  }, [mid, setMid]);

  const getDataCombined4 = async () => {
    const paylaod = {
      mid: mid,
      timeFrame: condition,
    };
    // console.log("Payload being sent:", paylaod);
    try {
      setShowLoader(true);
      setCombinedApiRes1([]);
      const response = await apiCallFnforPost(
        API_DASHBOARD_WITH_CONDITION4,
        paylaod
      );
      // console.log("Response received:", response);
      if (response.statusCode === 200) {
        // console.log("Successful responseData:", response.responseData);
        setDataForBoxes(response?.responseData);
        setShowLoader(false);
      } else {
        // console.log("Error in response:", response);
        setCombinedApiRes1([]);
        setShowLoader(false);
      }
    } catch (error) {
      // console.error("Error occurred:", error);
      setBoxData(true);
      setShowLoader(false);
    }
  };

  const getDataCombined1 = async () => {
    const paylaod = {
      mid: mid,
      timeFrame: condition,
    };
    // console.log("Payload being sent:", paylaod);
    try {
      setShowLoader(true);
      setCombinedApiRes1([]);
      const response = await apiCallFnforPost(
        API_DASHBOARD_WITH_CONDITION1,
        paylaod
      );
      // console.log("Response received:", response);
      if (response.statusCode === 200) {
        // console.log("Successful responseData:", response.responseData);
        setCombinedApiRes1(response?.responseData);
        setShowLoader(false);
      } else {
        // console.log("Error in response:", response);
        setCombinedApiRes1([]);
        setShowLoader(false);
      }
    } catch (error) {
      // console.error("Error occurred:", error);
      setBoxData(true);
      setShowLoader(false);
    }
  };

  const getDataCombined2 = async () => {
    const paylaod = {
      mid: mid,
      timeFrame: condition,
    };
    // console.log("Payload being sent:", paylaod);
    try {
      setShowLoader(true);
      setCombinedApiRes2([]);
      const response = await apiCallFnforPost(
        API_DASHBOARD_WITH_CONDITION2,
        paylaod
      );
      // console.log("Response received:", response);
      if (response.statusCode === 200) {
        // console.log("Successful responseData:", response.responseData);
        setCombinedApiRes2(response?.responseData);
        setShowLoader(false);
      } else {
        // console.log("Error in response:", response);
        setCombinedApiRes2([]);
        setShowLoader(false);
      }
    } catch (error) {
      // console.error("Error occurred:", error);
      setBoxData(true);
      setShowLoader(false);
    }
  };
  const getDataCombined3 = async () => {
    const paylaod = {
      mid: mid,
      timeFrame: condition,
    };
    // console.log("Payload being sent:", paylaod);
    try {
      setShowLoader(true);
      setCombinedApiRes3([]);
      const response = await apiCallFnforPost(
        API_DASHBOARD_WITH_CONDITION3,
        paylaod
      );
      // console.log("Response received:", response);
      if (response.statusCode === 200) {
        // console.log("Successful responseData:", response.responseData);
        setCombinedApiRes3(response?.responseData);
        setShowLoader(false);
      } else {
        // console.log("Error in response:", response);
        setCombinedApiRes3([]);
        setShowLoader(false);
      }
    } catch (error) {
      //  console.error("Error occurred:", error);
      setBoxData(true);
      setShowLoader(false);
    }
  };
  const getDataPayinServices = async () => {
    const paylaod = {
      mid: mid,
      timeFrame: condition,
    };
    try {
      setShowLoader(true);
      setPayinServices([]);
      const response = await apiCallFnforPost(
        FETCH_ALL_PAYIN_SERVICES,
        paylaod
      );
      if (response.statusCode === 200) {
        setPayinServices(response.responseData);
        setServicesPieChartData(
          response?.responseData?.map((item, i) => {
            return {
              id: i + 1,
              label: item.paymentService,
              value: item.percentage,
              color: serviceColors[item?.paymentService],
            };
          })
        );
        setShowLoader(false);
      } else {
        setPayinServices([]);
        setServicesPieChartData([]);
        setShowLoader(false);
      }
    } catch (error) {
      setPayinServices([]);
      setServicesPieChartData([]);
      setShowLoader(false);
    }
  };

  const getErrorCodeData = async () => {
    const payload = {
      mid: mid,
      timeFrame: condition,
    };
    setShowLoader(true); // Start loader when fetching data
    try {
      const response = await apiCallFnforPost(REPORT_ERROR_CODES, payload);
      if (response?.statusCode === 200) {
        const sortedData = response.data.sort((a, b) => {
          if (a.evokTxnCode === "Success") return -1;
          if (b.evokTxnCode === "Success") return 1;
          return 0;
        });

        setErrorCodeList(
          sortedData.map((item, i) => {
            return {
              id: i + 1,
              label: item.evokTxnCode,
              value: item.count,
              color: errorCodes[item.evokTxnCode],
            };
          })
        );
      } else {
        setErrorCodeList([]);
      }
    } catch (error) {
      setErrorCodeList([]);
    } finally {
      setShowLoader(false); // Stop loader after data is fetched
    }
  };

  useEffect(() => {
    getDataPayinServices();
  }, [mid, condition]);

  return (
    <div class="content-body">
      <FloatingIcon setCondition={setCondition} merchantData={merchantData} />
      <MerchantIcon setMid={setMid} />
      <div class="container-fluid">
        <div class="row invoice-card-row">
          <Card
            name="Total Payin"
            amount={dataForBoxes?.payin}
            color={"bg-primary"}
            icon={icon1}
            showLoader={showLoader}
          />
          <Card
            name="Payout Balance"
            imps={currentAvailable?.responseData2?.impsAmount}
            upiAmount={currentAvailable?.responseData2?.upiAmount}
            amount={
              parseFloat(currentAvailable?.responseData2?.impsAmount ?? 0) +
              parseFloat(currentAvailable?.responseData2?.upiAmount ?? 0)
            }
            color={"bg-secondary"}
            icon={icon2}
            showLoader={showLoader}
          />
          <Card
            name="Credit Balance"
            amount={currentAvailable?.responseData?.dropCreditAmount}
            color={"bg-info"}
            icon={icon3}
            showLoader={showLoader}
          />
          <Card
            name="Total Chargeback"
            amount={dataForBoxes?.chargeBackAmount}
            color={"bg-warning"}
            icon={icon4}
            showLoader={showLoader}
          />
        </div>
        <MiddleCard
          data={currentAvailable?.responseData2?.wallet}
          payinServices={payinServices}
          availablePayoutBalance={availablePayoutBalance}
          detailsOn={detailsOn}
        />
        <Button
          className="m-2"
          onClick={!detailsOn ? HandleDetailShow : HandleDetailHide}
        >
          {!detailsOn ? "Show More Detail" : "Hide Details"}
        </Button>
        {detailsOn ? (
          <>
            {" "}
            <div class="row mt-2">
              <PieCharts data={servicesPieChartData} type={"services"} />
              <PreviousTxns
                data={boxData}
                payout={currentAvailable?.responseData2?.impsAmount}
                dataW={currentAvailable?.responseData2?.wallet}
              />
              <div class="col-xl-6 col-xxl-6">
                <div class="row">
                  <VirtualAssistant />
                  <TotalTransaction
                    title="Total Transactions"
                    data={totalTransactionData.totalCount}
                  />
                  <TotalTransaction
                    title="Total Success Txn"
                    data={totalTransactionData.successCount}
                  />
                  <TotalTransaction
                    title="Total Failed Txn"
                    data={totalTransactionData.failureCount}
                  />
                  <TotalTransaction
                    title="Total Declined Txn"
                    data={totalTransactionData.declined}
                  />
                  <TotalTransaction
                    title="Payout Total Transactions"
                    data={totalTransactionData.payoutTotalCount}
                  />
                  <TotalTransaction
                    title="Payout Total Success Txn"
                    data={totalTransactionData.payoutSuccessCount}
                  />
                  <TotalTransaction
                    title="Payout Total Failed Txn"
                    data={totalTransactionData.payoutFailureCount}
                  />
                  <TotalTransaction
                    title="Payout Pending Txn"
                    data={totalTransactionData.payoutPendingCount}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <SimpleBarChart condition={condition} mid={mid} />
              <PieCharts data={errorCodelist} showLoader={showLoader} />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default DashBoard;
